












































import { defineComponent, PropType } from '@vue/composition-api';

export default defineComponent({
  name: 'DropdownMenuItemBase',
  props: {
    icon: {
      type: String as PropType<
        | 'check'
        | 'activeFolder'
        | 'inactiveFolder'
        | 'loading'
        | 'createProject'
        | 'link'
      >,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },
});
